import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Lives at `lib/utils.ts`: shadcn's `"utils"` alias points here, so generated components
 * import this instead of creating a second `cn()` per workspace.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
